import { useQuery } from "react-query"
import customAxios from "../../utils/customAxios"

const axios = customAxios()

interface VerifyMobileParamsType {
  sessionId: string
  verificationCode: string
}

const fetchVerifyMobile = (queryKey: any) => {
  const params: VerifyMobileParamsType = queryKey[1]
  return axios.get(
    `/users/register/verify_mobile/?session_id=${params.sessionId}&user_type_number=${params.verificationCode}`
  )
}

const useVerifyMobile = (params: VerifyMobileParamsType) => {
  return useQuery(["verifyMobile", params], fetchVerifyMobile, {
    staleTime: 100000,
    refetchOnWindowFocus: false,
    enabled: false,
  })
}

export default useVerifyMobile
